import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { SESSION_EXP_STORAGE_KEY } from '../../constants/auth';
import { useHandleLogout } from '../../hooks/useHandleLogout';

// Frequency to check session expiration time against current time
const SESSION_CHECK_INTERVAL_MS = 1000;

/*  Check whether we've passed the current session's expiration time on a running interval.
    When the expiration time has passed, fully clear the state.
*/
export default function SessionExpirationTimer() {
  const logoutUser = useHandleLogout();

  useEffect(() => {
    const checkForSessionExpiration = () => {
      const sessionExpTimeMs = localStorage.getItem(SESSION_EXP_STORAGE_KEY);
      if (sessionExpTimeMs != null) {
        const currTimeInMs = Date.now();
        if (currTimeInMs > sessionExpTimeMs) {
          logoutUser();
          toast.info('Session expired. Please log in again.');
        }
      }
    };
    let intervalID = setInterval(checkForSessionExpiration, SESSION_CHECK_INTERVAL_MS);
    return () => clearInterval(intervalID);
  }, [logoutUser]);

  return null;
}
